<template>
  <div class="container pt-0">
    <a id="downloadLink" class="invisible" ></a>
    <div class="flex-grid">
      <div v-for="order in orders.data" class="col-3-1-1">
        <div class="card order-card">
          <span class="status-label done">{{ getOrderStatusShortText(order)[0] }}</span>
          <h3>{{ order.shop.name }}</h3>
          <div class="items">
            <span>am <strong>{{ formatDate(order.created_at) }}</strong>, Rechnungsbetrag: <strong>{{ getOrderPrice(order.total, order.shop) }}</strong></span>
            <span v-for="item in order.orderItems" >{{ item.name }} {{ getTextFromUnit(item.unit) }}</span>
          </div>
          <div class="buttons">
            <button @click.prevent="downloadInvoice(order)" v-if="isOrderPaid(order)" class="btn black outline">Rechnung herunterladen</button>
            <button @click.prevent="goTo('orderSummary', {'order': order.uid} )" class="btn black outline">Details der Bestellung einsehen</button>
          </div>
        </div>
      </div>
    </div>
    <div class="load-more-container" v-if="orders.links.next && !loadingMore">
      <button class="btn orange" @click.prevent="loadMore">Mehr laden</button>
    </div>
    <div v-if="loadingMore" class="flex items-center">
      <div class="flex-1 text-grey-darker text-center px-4 py-4 m-4">
        <cg-loader :show="true"></cg-loader>
      </div>
    </div>
  </div>
</template>

<script>
  import {mapGetters, mapActions} from 'vuex'
  import formatting from '@/mixins/formatting.js'
  import helpers from '@/mixins/helpers.js'
  import CgLoader from '@/components/menus/cgLoader'

  export default {
    name: 'orders',
    components: {
      CgLoader
    },
    created () {
      this.getOrders({user: this.account.uid})
      this.$store.commit('CHECKOUT_SET_CART_JUST_INTO_ORDER', false)
    },
    data () {
      return {
        loadingMore: false
      }
    },
    mixins: [formatting, helpers],
    methods: {
      ...mapActions([
        'getOrders',
        'getMore',
        'downloadInvoiceAction'
      ]),
      hasToPay (order) {
        return !this.isOrderPaid(order) && this.isOrderPaymentWarning(order)
      },
      downloadInvoice (order) {
        var self = this
        this.downloadInvoiceAction({
          order: order.uid,
          cb (response) {
            var blob = new Blob([response], {type: 'application/pdf'})
            let link = document.getElementById('downloadLink')
            link.href = window.URL.createObjectURL(blob)
            link.download = 'Bestellung-' + order.shop.name + '.pdf'
            link.click()
          },
          errorCb () {
            self.$toasted.error('Leider ist ein Fehler aufgetreten. Bitte versuche es später', {
              theme: 'primary',
              position: 'top-right',
              duration: 10000,
              action: {
                text: 'X',
                class: 'toastBtn',
                onClick: (e, toastObject) => {
                  toastObject.goAway(0)
                }
              },
              icon: 'close'
            })
          }
        })
      },
      loadMore () {
        var self = this
        self.loadingMore = true
        this.getMore({
          url: this.orders.links.next,
          commit: 'USER_ORDER_PAGE',
          cb () {
            self.loadingMore = false
          },
          errorCb () {
            self.loadingMore = false
          }
        })
      }
    },
    computed: {
      ...mapGetters({
        account: 'auth_get_account',
        loading: 'options_is_loading',
        orders: 'user_get_orders'
      })
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/user/orders.vue